import { MutableRefObject } from 'react';
import { CameraControls } from '@react-three/drei';
import { Annotation } from 'features/three-view/state/threeAtoms';

export const annotationClick = async (
  cameraRef: MutableRefObject<CameraControls>,
  annotation: Annotation
) => {
  if (!cameraRef.current) return;

  const { lookAt, position, cameraUp } = annotation;

  cameraRef.current.camera.up.set(cameraUp.x, cameraUp.y, cameraUp.z);
  cameraRef.current.updateCameraUp();
  await cameraRef.current.setLookAt(
    position.x, position.y, position.z,
    lookAt.x, lookAt.y, lookAt.z,
    true
  );
  await new Promise(resolve => setTimeout(resolve, 100));
};
